/* Aurant · regalos en el carrito. Lo arma _PROGRAMA/armar_carrito.py: no se edita a mano.
   Regla (oferta del 10-oct-2026, «Compra 2, llévate 1 GRATIS»): desde 3 bálsamos va el regalo misterioso; desde 5, además la tarjeta.
   Con 1 o con 2 bálsamos no va ningún regalo. Un regalo de cada uno por carrito. La cantidad de cada regalo llega en su «desde».
   El producto «Envío Gratis» llega marcado «activo: false» (ajuste del tema apagado): no se agrega nunca y, si un carrito viejo lo trae, se saca.
   Esta pieza mete los regalos que tocan, saca los que no tocan y saca cualquier regalo que Shopify no dejó en $0.
   Un regalo que ya está en el carrito se cambia por la clave de su línea. La variante se usa solo para agregar uno que no está.
   Quien deja el regalo en $0 es Shopify (descuento automático «Compra X y obtén Y», o el producto en precio 0). Aquí no se aplica ningún código.
   Quién vuelve a pintar: con el carrito propio encendido, AurantCarrito.refrescar (esta pieza solo cuadra y avisa si cambió algo).
   Con el carrito propio apagado, esta pieza repinta el cajón de Elixir.
   Uso desde otras piezas: AurantRegalos.cuadrar() devuelve una promesa con { cambio, secciones }. AurantRegalos.paraAgregar(lineas) devuelve
   los regalos que hay que sumar a un pedido. AurantRegalos.rechazar(variante) anota que el cliente quitó ese regalo. */
(function () {
  if (window.AurantRegalos) { return; }
  var nodo = document.getElementById('aurant-regalos-datos'), cfg = null;
  try { cfg = JSON.parse(nodo.textContent); } catch (e) { return; }
  var REGALOS = (cfg.regalos || []).filter(function (g) { return g && g.id; });
  if (!REGALOS.length) { return; }
  var PROPIO = !!cfg.propio;                       // el carrito propio está encendido
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EN_PAGINA_CARRITO = /\/cart\/?$/.test(window.location.pathname);
  var AROMAS = {}, ES_REGALO = {}, VARIANTES = {}, HAY_VARIANTES = false;
  (cfg.aromas || []).forEach(function (h) { AROMAS[h] = 1; });
  (cfg.variantes || []).forEach(function (v) { VARIANTES[v] = 1; HAY_VARIANTES = true; });
  REGALOS.forEach(function (g) { ES_REGALO[g.id] = g; });
  var CLAVE = 'aurant_regalos_freno', CLAVE_NO = 'aurant_regalos_quitados', ESPERA = 60000;
  var ultimo = cfg.carrito && cfg.carrito.items ? cfg.carrito : null;   // el carrito tal como venía pintado en la página
  var enCurso = null, otraVez = false, abrirPendiente = false;
  var memoria = {};                                // por si el navegador no deja usar sessionStorage

  function guardado(k) { try { return JSON.parse(sessionStorage.getItem(k) || '{}') || {}; } catch (e) { return memoria[k] || {}; } }
  function guardar(k, v) { memoria[k] = v; try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function pedir(url, opc) {
    return fetch(url, opc).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: false, j: {} }; }); });
  }
  /* «secciones»: si quien llama las pide, Shopify devuelve en la misma respuesta el carrito ya pintado. Así no hace falta pedirlo aparte. */
  function mandar(ruta, cuerpo, secciones) {
    if (secciones) { cuerpo.sections = secciones; cuerpo.sections_url = window.location.pathname; }
    return pedir(R + ruta, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) });
  }
  function esCarrito(j) { return !!j && Array.isArray(j.items) && typeof j.item_count === 'number'; }
  function leer() {
    return pedir(R + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { if (r.ok && r.j && r.j.items) { ultimo = r.j; return r.j; } return null; });
  }
  function balsamos(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (!ES_REGALO[it.variant_id] && AROMAS[it.handle]) { n += it.quantity; } });
    return n;
  }
  function cuantos(cart, id) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.variant_id === id) { n += it.quantity; } });
    return n;
  }
  /* Las líneas de un regalo. El mismo regalo puede venir en más de una línea: una con una propiedad y otra sin, por ejemplo. */
  function lineasDe(cart, id) { return (cart.items || []).filter(function (it) { return it.variant_id === id; }); }
  /* Lo que hay en el carrito, línea por línea. Sirve para saber si una llamada de verdad cambió algo. */
  function firmaDe(cart) { return (cart.items || []).map(function (it) { return (it.key || it.variant_id) + 'x' + it.quantity + ':' + it.final_line_price; }).join(';'); }
  /* ¿Le toca este regalo a un carrito con n bálsamos? Un regalo apagado en Ajustes del tema (activo: false) no toca nunca:
     no se agrega y, si está en el carrito, se saca. Es la única regla, para las dos puertas: cuadrar y paraAgregar. */
  function toca(g, n) { return g.activo !== false && n >= g.desde; }
  /* Freno: si un regalo no entró o no quedó gratis, no se reintenta con la misma cantidad de bálsamos durante un minuto. Evita el bucle.
     Se anota por regalo Y por cantidad de bálsamos: así, si el cliente pasa de 3 a 5 y vuelve a 3, tampoco se reintenta con 3. */
  function frenar(id, n) {
    var f = guardado(CLAVE), ahora = Date.now(), vivos = {};
    Object.keys(f).forEach(function (k) { if (ahora - f[k] < ESPERA) { vivos[k] = f[k]; } });
    vivos[id + ':' + n] = ahora; guardar(CLAVE, vivos);
  }
  function frenado(id, n) { var t = guardado(CLAVE)[id + ':' + n]; return !!t && (Date.now() - t) < ESPERA; }
  /* Si el cliente quita un regalo con la equis, ese regalo no se le vuelve a meter solo (se guarda en la pestaña). Se olvida cuando agrega
     un bálsamo de nuevo o cuando el carrito queda sin bálsamos: ahí los regalos vuelven. Diego, 10-oct-2026: probando quitó los regalos,
     vació el carrito, volvió a agregar y ya no le salían en toda la visita. */
  function rechazar(id) { id = Number(id); if (!ES_REGALO[id]) { return; } var q = guardado(CLAVE_NO); q[id] = 1; guardar(CLAVE_NO, q); }
  function rechazado(id) { return !!guardado(CLAVE_NO)[id]; }
  function olvidarQuitados() { var q = guardado(CLAVE_NO), hay = false, k; for (k in q) { hay = true; break; } if (hay) { guardar(CLAVE_NO, {}); } }

  /* Lo que se suma a un pedido antes de mandarlo: los regalos que tocarán después de agregar esos bálsamos y que todavía no están.
     Solo cuentan como bálsamo las líneas que son variantes de un aroma. */
  function paraAgregar(nuevos) {
    var base = ultimo || { items: [] }, n = balsamos(base), salida = [];
    (nuevos || []).forEach(function (i) { if (i && (!HAY_VARIANTES || VARIANTES[i.id])) { n += i.quantity || 1; } });
    if (n > balsamos(base)) { olvidarQuitados(); }   // agrega un bálsamo: los regalos que había quitado vuelven a tocar
    REGALOS.forEach(function (g) { if (toca(g, n) && cuantos(base, g.id) === 0 && !frenado(g.id, n) && !rechazado(g.id)) { salida.push({ id: g.id, quantity: 1 }); } });
    return salida;
  }

  /* Solo con el carrito propio apagado: repinta el cajón de Elixir. */
  function repintarElixir(abrir) {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || !cajon.renderContents) {
      /* Página del carrito, sin cajón: se recarga solo si hubo cambio. */
      if (EN_PAGINA_CARRITO) { window.location.reload(); }
      return Promise.resolve();
    }
    if (!abrir) {
      try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aurant-regalos' }); return Promise.resolve(); } } catch (e) {}
    }
    return fetch(R + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      cajon.classList.remove('is-empty');
      if (abrir) { cajon.renderContents({ sections: s }); return; }
      var viejo = document.querySelector('cart-drawer'), nuevo = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (window.cartFunctions && window.cartFunctions.updateCartDrawer && viejo && nuevo) { window.cartFunctions.updateCartDrawer(viejo, nuevo, false); }
    }).catch(function () {});
  }

  /* Una pasada. opc.carrito: el carrito recién devuelto por Shopify, si quien llama ya lo tiene (ahorra una llamada).
     Devuelve { cambio, secciones }: si cambió algo y, si se pidieron, las secciones que vinieron con el último cambio. */
  function pasada(opc) {
    var cambio = false, secciones = null, pide = opc.secciones || null, puestos = {}, firma0 = null;
    function anotar(r) {   // cart/update.js devuelve el carrito entero: no hace falta volver a pedirlo
      cambio = true; secciones = (r.j && r.j.sections) || null;
      if (esCarrito(r.j)) { ultimo = r.j; return r.j; }
      return leer();
    }
    var inicio = esCarrito(opc.carrito) ? Promise.resolve(opc.carrito) : leer();
    return inicio.then(function (cart) {
      if (!cart) { return null; }
      ultimo = cart; firma0 = firmaDe(cart);
      var n = balsamos(cart), pedidos = {}, hay = false;
      if (n === 0) { olvidarQuitados(); }   // carrito sin bálsamos: se parte de cero
      /* Lo que ya está en el carrito se cambia por la CLAVE de su línea, no por la variante. Con la variante, si el regalo viene en dos líneas,
         Shopify solo cambia la primera que encuentra y el carrito no se cuadraba nunca (revisión del 10-oct-2026).
         «cuantas» es 0 o 1: la primera línea queda con esa cantidad y las demás salen. */
      function dejar(g, cuantas) {
        lineasDe(cart, g.id).forEach(function (it, i) { var q = i === 0 ? cuantas : 0; if (it.quantity !== q) { pedidos[it.key || g.id] = q; hay = true; } });
      }
      REGALOS.forEach(function (g) {
        var tiene = cuantos(cart, g.id), va = toca(g, n);
        if (!va && tiene > 0) { dejar(g, 0); }
        else if (va && tiene === 0 && !frenado(g.id, n) && !rechazado(g.id)) { pedidos[g.id] = 1; puestos[g.id] = 1; hay = true; }
        else if (va && tiene > 1) { dejar(g, 1); }
      });
      if (!hay) { return cart; }
      /* Una sola llamada para todo. Si Shopify la rechaza (un regalo agotado, por ejemplo), se intenta regalo por regalo. */
      return mandar('cart/update.js', { updates: pedidos }, pide).then(function (r) {
        if (r.ok) { return anotar(r); }
        var cola = Promise.resolve(cart);
        Object.keys(pedidos).forEach(function (id) {
          cola = cola.then(function (c) {
            var u = {}; u[id] = pedidos[id];
            return mandar('cart/update.js', { updates: u }, pide).then(function (r2) {
              if (r2.ok) { return anotar(r2); }
              if (puestos[id]) { frenar(Number(id), n); delete puestos[id]; }   // solo lo que se quiso agregar: ahí «id» es la variante
              return c;
            });
          });
        });
        return cola;
      });
    }).then(function (cart) {
      if (!cart) { return null; }
      /* Nunca dejar un regalo cobrándose: si Shopify no lo dejó en $0, sale del carrito. Y si un regalo pedido no entró, queda frenado. */
      var n = balsamos(cart), sacar = {}, hay = false;
      (cart.items || []).forEach(function (it) { if (ES_REGALO[it.variant_id] && it.final_line_price > 0) { sacar[it.key || it.variant_id] = 0; frenar(it.variant_id, n); hay = true; } });
      Object.keys(puestos).forEach(function (id) { if (cuantos(cart, Number(id)) === 0) { frenar(Number(id), n); } });
      if (!hay) { return cart; }
      return mandar('cart/update.js', { updates: sacar }, pide).then(function (r) { return r.ok ? anotar(r) : cart; });
    }).then(function (cart) {
      /* Shopify puede contestar «bien» y dejar el carrito como estaba. Eso no es un cambio: no se repinta ni, en la página /cart, se recarga.
         Sin esto, un carrito que no se dejaba cuadrar dejaba la página /cart recargando sin parar (revisión del 10-oct-2026). */
      if (cambio && cart && firma0 !== null && firmaDe(cart) === firma0) { cambio = false; secciones = null; }
      return { cambio: cambio, secciones: secciones };
    });
  }

  function cuadrar(opc) {
    opc = opc || {};
    var abrir = !PROPIO && !!opc.abrir;
    if (enCurso) { otraVez = true; if (abrir) { abrirPendiente = true; } return enCurso; }
    enCurso = pasada(opc).catch(function () { return { cambio: false, secciones: null }; }).then(function (res) {
      /* Sin bucles: una pasada que no cambia nada no repinta. */
      if (PROPIO || !(res.cambio || abrir)) { return res; }
      return repintarElixir(abrir).then(function () { return res; }, function () { return res; });
    }).then(function (res) {
      enCurso = null;
      if (!otraVez) { return res; }
      otraVez = false; var a = abrirPendiente; abrirPendiente = false;
      /* Mientras se cuadraba llegó otro pedido de cuadrar: se hace una pasada más, con el carrito recién leído. */
      return cuadrar({ abrir: a, secciones: opc.secciones }).then(function (r2) { return { cambio: res.cambio || r2.cambio, secciones: r2.cambio ? r2.secciones : null }; });
    });
    return enCurso;
  }

  /* ¿Hace falta mirar? Solo si lo que hay no calza con lo que debería haber. Así una página con el carrito en orden no pide nada a Shopify. */
  function descuadrado(cart) {
    if (!cart) { return true; }
    var n = balsamos(cart), mal = false;
    REGALOS.forEach(function (g) {
      var tiene = cuantos(cart, g.id), va = toca(g, n);
      if ((!va && tiene > 0) || (va && tiene > 1) || (va && tiene === 0 && !frenado(g.id, n) && !rechazado(g.id))) { mal = true; }
    });
    (cart.items || []).forEach(function (it) { if (ES_REGALO[it.variant_id] && it.final_line_price > 0) { mal = true; } });
    return mal;
  }

  /* La pieza cuadra por su cuenta: al cargar la página, o porque otra pieza del tema cambió el carrito.
     Con el carrito propio, después de cuadrar quien repinta es AurantCarrito.refrescar, y solo si cambió algo. */
  function sola() {
    return cuadrar().then(function (res) {
      if (!PROPIO || !res || !res.cambio) { return; }
      if (EN_PAGINA_CARRITO) { window.location.reload(); return; }
      var c = window.AurantCarrito;
      if (c && c.refrescar) { c.refrescar({ cuadrado: true }); } else { window.__aurantPendiente = { que: 'refrescar', opc: { cuadrado: true } }; }
    });
  }
  var reloj = null;
  function avisado() { clearTimeout(reloj); reloj = setTimeout(sola, 120); }
  /* Avisos de las piezas de Elixir. Con el carrito propio no se escuchan, salvo en la página /cart: todo lo demás entra por el puente
     (open, renderContents y refreshCartDrawer del cajón de Elixir llaman a AurantCarrito.refrescar, que cuadra antes de pintar). */
  if (!PROPIO) { document.addEventListener('cart-drawer:update', avisado); }
  if (!PROPIO || EN_PAGINA_CARRITO) {
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || (e.source !== 'aurant-regalos' && e.source !== 'aurant-carrito')) { avisado(); } }); } } catch (e) {}
  }

  window.AurantRegalos = { cuadrar: cuadrar, paraAgregar: paraAgregar, rechazar: rechazar, esRegalo: function (id) { return !!ES_REGALO[Number(id)]; } };
  if (descuadrado(ultimo)) { sola(); }
})();
